module.exports = __webpack_public_path__ + "img/equipe.d91133a1.jpg";